import { useDirtyState } from '@calendly/form'
import { nanoid } from 'nanoid'
import { useEffect, useRef } from 'react'

import changeSet from 'core/change_set'

export const DirtyTracking = ({ formId }) => {
  const id = useRef(formId || nanoid())
  const isDirty = useDirtyState()
  useEffect(() => {
    if (isDirty) {
      changeSet.dirty(id.current)
    } else {
      changeSet.clear(id.current)
    }
  }, [isDirty])

  useEffect(() => () => changeSet.clear(id.current), [])

  return null
}
